function getPrimaryRorName(item) {
  const names = item.names || [];
  const rorDisplay = names.find((name) => name.types?.includes("ror_display"));
  if (rorDisplay?.value) {
    return rorDisplay.value;
  }

  const label = names.find((name) => name.types?.includes("label"));
  if (label?.value) {
    return label.value;
  }

  const english = names.find((name) => name.lang === "en");
  if (english?.value) {
    return english.value;
  }

  const nonAcronym = names.find((name) => !name.types?.includes("acronym"));
  if (nonAcronym?.value) {
    return nonAcronym.value;
  }

  return names[0]?.value || item.id;
}

function mapRorOrganization(item) {
  const primaryName = getPrimaryRorName(item);

  const location = item.locations?.[0]?.geonames_details;
  const aliases =
    item.names
      ?.filter(
        (name) =>
          name.types?.includes("alias") || name.types?.includes("acronym")
      )
      .map((name) => name.value) || [];

  return {
    ror_id: item.id,
    ror_name: primaryName,
    country: location?.country_name,
    city: location?.name,
    aliases,
  };
}

export function normalizeRorIdInput(input) {
  const trimmed = input.trim();
  if (!trimmed) {
    return null;
  }

  const urlMatch = trimmed.match(/^https?:\/\/ror\.org\/([a-z0-9]+)$/i);
  if (urlMatch) {
    return `https://ror.org/${urlMatch[1].toLowerCase()}`;
  }

  const codeMatch = trimmed.match(/^[a-z0-9]{5,9}$/i);
  if (codeMatch) {
    return `https://ror.org/${codeMatch[0].toLowerCase()}`;
  }

  return null;
}

export async function searchRorOrganizations(query, limit) {
  const response = await fetch(
    `https://api.ror.org/v2/organizations?query=${encodeURIComponent(query)}`
  );

  if (!response.ok) {
    throw new Error(`ROR API responded with status: ${response.status}`);
  }

  const data = await response.json();
  const results = (data.items || []).map(mapRorOrganization);

  return limit ? results.slice(0, limit) : results;
}

export async function fetchRorOrganization(rorIdInput) {
  const rorId = normalizeRorIdInput(rorIdInput);
  if (!rorId) {
    throw new Error("Invalid ROR ID format");
  }

  const rorIdCode = rorId.match(/ror\.org\/([a-z0-9]+)$/i)?.[1];
  if (!rorIdCode) {
    throw new Error("Invalid ROR ID format");
  }

  const response = await fetch(
    `https://api.ror.org/v2/organizations/${rorIdCode}`
  );

  if (!response.ok) {
    throw new Error(`ROR API responded with status: ${response.status}`);
  }

  const data = await response.json();
  return mapRorOrganization(data);
}

export function getGoogleSearchUrl(query) {
  return `https://www.google.com/search?q=${encodeURIComponent(query)}`;
}
